import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from "@ngrx/store";
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AuthLogoutAction } from '@modules/users/store/user.actions';
import {ErrorService} from "@services/error.service";
import {LOGSEVERITY, LOGTYPE} from "@core/app.costants";
import {WatchdogService} from "@services/watchdog.service";

@Injectable()
export class AuthExpiredInterceptor implements HttpInterceptor {
  constructor(private store: Store, private errorService: ErrorService, private watchdog: WatchdogService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap({
        error: (err: any) => {
          if (err instanceof HttpErrorResponse) {
            if (err.status === 401) {
              const errorMessage = "Sessione scaduta.";
              this.errorService.setError(errorMessage);

              this.watchdog.writeWatchdog({
                type: LOGTYPE.INFO,
                severity: LOGSEVERITY.NONE,
                message: "L'utente ha effettuato il logout",
              });

              this.store.dispatch(AuthLogoutAction());
            }
          }
        }
      })
    );
  }
}
